import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

import { Menu } from './ClickableFloatingDropdownMenu';
import AppService from '@/utils/AppService';
import { ExtendedReactElement } from '@/utils/types';

export enum CreateNodeShortcutCommand {
	EndRun = 'endRun',
	Formula = 'formula',
	Branch = 'branch',
	AI = 'ai',
	SendAnEmail = 'sendAnEmail',
	Interface = 'interface',
	Integration = 'integration',
	MiniApp = 'miniApp',
	SeeAllOptions = 'seeAllOptions',
}

export const NewNodeFloatingMenu = ({
	onShortcutClick,
	children,
	isEndRunAllowed,
	style,
	setIsOpen,
}: ExtendedReactElement<{
	isEndRunAllowed: boolean;
	onShortcutClick: (shortcut: CreateNodeShortcutCommand) => void;
	setIsOpen?: (isOpen: boolean) => void;
}>) => {
	const LOGIC_CATEGORY_ITEMS = [
		{
			label: 'Branch',
			onClick: () => onShortcutClick(CreateNodeShortcutCommand.Branch),
			icon: AppService.getServiceActionCollectionIconName('logic'),
		},
		{
			label: 'Formula',
			onClick: () => onShortcutClick(CreateNodeShortcutCommand.Formula),
			expandable: true,
			icon: AppService.getServiceActionCollectionIconName('formulas'),
		},
		{
			label: 'AI',
			onClick: () => onShortcutClick(CreateNodeShortcutCommand.AI),
			expandable: true,
			icon: AppService.getServiceActionCollectionIconName('ai'),
		},
		...(isEndRunAllowed
			? [{ label: 'End run', onClick: () => onShortcutClick(CreateNodeShortcutCommand.EndRun), icon: ServiceSlugs.EndRun }]
			: []),
	];
	return (
		<Menu
			children={children}
			categories={[
				{
					items: [
						{ label: 'Interface', icon: ServiceSlugs.Widgets, onClick: () => onShortcutClick(CreateNodeShortcutCommand.Interface) },
						{ label: 'Mini-app', icon: 'mini-apps', onClick: () => onShortcutClick(CreateNodeShortcutCommand.MiniApp), expandable: true },
					],
				},
				{
					items: [
						{
							label: 'Integration',
							icon: 'integrations-square',
							onClick: () => onShortcutClick(CreateNodeShortcutCommand.Integration),
							expandable: true,
						},
						// {
						// 	label: 'Send an email',
						// 	onClick: () => onShortcutClick(CreateNodeShortcutCommand.SendAnEmail),
						// 	icon: ServiceSlugs.TransactionalEmails,
						// }, // TODO: uncomment when email service is ready
					],
				},
				{
					items: LOGIC_CATEGORY_ITEMS,
				},
				{
					items: [{ label: 'See all options', onClick: () => onShortcutClick(CreateNodeShortcutCommand.SeeAllOptions), expandable: true }],
				},
			]}
			style={style}
			setIsOpen={setIsOpen}
		/>
	);
};
